import { render, staticRenderFns } from "./SearchProduct.vue?vue&type=template&id=654c0944"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"
import style0 from "./SearchProduct.vue?vue&type=style&index=0&id=654c0944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports